/***
 * Created on 2024/11/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import DeleteQidSuccess from '../component/delete_qid_success';
export default DeleteQidSuccess;